export default __webpack_public_path__ + "static/media/icon-pickup-default.0bfde45e.svg";